import React from 'react';
import { Modal } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import i18n from '../../lib/reacti18n';
import { CALL_US_CONTACT_INFO } from '../../contactUs/constants/PropTypesShapes';
import { trackLink } from '../../lib/analytics-helper';
import Page from '../../lib/page';

/**
 * Innovation Guild: search only experiment. call us container
 */
const label = {
  dialingHeader: i18n.message('smarthelp/callUs.call.dialing.header'),
  dialingAlterSubHeader: i18n.message('smarthelp/callUs.call.dialing.customer.subInst.alterHeader'),
  webpinInst: i18n.message('smarthelp/callUs.call.dialing.webpin.spInst'),
  webpinSubHeader: i18n.message('smarthelp/callUs.call.dialing.webpin.subHeader'),
  webpinNoticeAlt: i18n.message('smarthelp/callUs.call.dialing.webpin.subInstAlt'),
  serviceHoursHeader: i18n.message('smarthelp/callUs.callUs.serviceHours'),
  dialingSubBody: i18n.message('smarthelp/callUs.call.dialing.customer.subInst.body'),
  additionInst: i18n.message('smarthelp/callUs.callUs.splInstruction'),
};

const ModalCallUsContainer = function (props) {
  const phoneNumberClickTracker = (event, number) => {
    event.preventDefault();
    trackLink({ id: 'callPage', link: `channel-dialing|call|${number}` });
    return window.open(`tel:${number}`, '_self');
  };

  return (
    <Modal isOpen={props.state} onClose={props.closeModalFunc} title={label.dialingHeader}>
      <div className="channel-new-call-us-container">
        <div className="channel-new-call-us-main-content">
          <div className="channel-new-dialing-container">
            <div className="channel-new-dialing-phone-main-content">
              <div>
                <h2 className="channel-new-call-dialing-inst-header channel-new-call-dialing__desktop">
                  {label.dialingAlterSubHeader}
                </h2>
              </div>
              <div className="channel-new-call-webpin-container">
                <div className="channel-new-call-webpin-instruction">{label.webpinInst}</div>
                <div className="channel-new-call-webpin-message-content">
                  <div className="channel-new-call-webpin-content-header">{label.webpinSubHeader}</div>
                  <div className="channel-new-call-webpin-content-body">{props.data.contactInfo.web_pin}</div>
                </div>
                <div className="channel-new-call-webpin-content-notice">{label.webpinNoticeAlt}</div>
              </div>
              <div>
                <div className="channel-new-call-dialing-numbers call-webpin">
                  <div className="channel-new-call-number-item">
                    <a
                      href={`tel:${props.data.contactInfo.phoneNumbers[0]}`}
                      className="channel-new-call-contact-number"
                      // eslint-disable-next-line react/jsx-no-bind
                      onClick={(e) => phoneNumberClickTracker(e, props.data.contactInfo.phoneNumbers[0])}
                    >
                      {props.data.contactInfo.phoneNumbers[0]}
                    </a>
                  </div>
                </div>
              </div>
              <div className="channel-new-dialing-instruction-main-content">
                <div className="channel-new-call-service-hours-container">
                  <h2 className="channel-new-call-customer-hours-title">{label.serviceHoursHeader}</h2>
                  <div className="channel-new-call-customer-hours">
                    <ul className="channel-new-call-customer-hours-body">
                      <li className="new-service-hour-item">
                        {Page.getHTMLElement({ message: props.data.contactInfo.prefferedHoo, useHTML: true })}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="channel-new-call-special-instruction">
                  {Page.getHTMLElement({ message: props.data.contactInfo.Special_Instruction, useHTML: true })}
                </div>
                <div>
                  <div className="channel-new-call-dialing-inst-body">{label.dialingSubBody}</div>
                </div>
                <div className="channel-new-call-dialing-addition-inst">{label.additionInst}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

ModalCallUsContainer.propTypes = {
  state: PropTypes.bool.isRequired,
  closeModalFunc: PropTypes.func.isRequired,
  data: PropTypes.shape(CALL_US_CONTACT_INFO).isRequired,
};

export default ModalCallUsContainer;
